import {
  INITIALISE_ACCORDION,
  TOGGLE_ACCORDION,
} from './actions';

const initialise = (state, { id, itemCount, isOpen }) => ({
  ...state,
  [id]: [...Array(itemCount).keys()].map(() => ({ isOpen })),
});

const toggle = (state, { id, index }) => ({
  ...state,
  [id]: state[id].map((item, mapIndex) => {
    if (index === mapIndex) {
      return {
        ...item,
        isOpen: !item.isOpen,
      };
    }
    return item;
  }),
});

const reducer = {
  [INITIALISE_ACCORDION]: initialise,
  [TOGGLE_ACCORDION]: toggle,
};

const initialState = {};

export default (state = initialState, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
